// @flow

import React from "react";
import { Map, AddressMap, AddressPins } from "@2po-c21/components";

import style from "./style.module.scss";

type Props = {
    property: *,
};

const PropertyLocation = ({ property }: Props) => {
    const coordinates = property.location;
    const { latitude, longitude } = coordinates;

    const address = property.address;
    const { street, number, box, postalCode, city } = address;

    const addressString = box
        ? `${street} ${number}, ${box}, ${postalCode} ${city}`
        : `${street} ${number}, ${postalCode} ${city}`;

    return (
        <div className={style.propertyLocationWrapper}>
            {coordinates && (
                <div className={style.mapContainer}>
                    <Map
                        initial={{
                            viewport: {
                                latitude: latitude,
                                longitude: longitude,
                                zoom: 12,
                            },
                        }}
                    >
                        <AddressPins>
                            <AddressMap
                                latitude={latitude}
                                longitude={longitude}
                                className={style.propertyLocationPin}
                                address={addressString}
                            />
                        </AddressPins>
                    </Map>
                </div>
            )}
        </div>
    );
};

export default PropertyLocation;
